// Set `__webpack_public_path__`, which will get prepended to chunks requested
// by Webpack, redirecting request to assets to the CDN.
__webpack_public_path__ = 'https://assets.staging.komoju-dev.com/packs/';
